import type { HTMLAttributes } from "react";

import { styled } from "simplydo/react/styled";
import { Slot } from "simplydo/react/ui/utils";

type StyledSearchItemProps = HTMLAttributes<HTMLElement> & {
  $active?: boolean;
  asChild?: boolean;
};

const SearchItemRoot = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;

  cursor: pointer;

  padding: 6px 10px;
  font-size: 1rem;
  line-height: 1rem;
  border-radius: 5px;

  gap: 4px;

  width: 100%;
  margin: 0;
  background-color: ${({ $active }) => ($active ? "#e9ebee" : "transparent")};
  word-break: break-word;

  i {
    flex: 0 0 auto;
  }

  img {
    margin-right: 0.45rem !important;
  }

  span {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.1rem;
  }
`;

const StyledSearchItem = ({
  $active,
  asChild,
  children,
  ...props
}: StyledSearchItemProps) => (
  <SearchItemRoot as={asChild ? Slot : undefined} $active={$active} {...props}>
    {children}
  </SearchItemRoot>
);

export { StyledSearchItem };
